/**
 * Kolor akcentu — jednocześnie kolor pionka na planszy.
 *
 * Definicja stoi w `shared/`, a nie w `web/`, bo od czasu gier planszowych
 * potrzebuje jej także serwer: pionka widzą pozostali gracze, więc barwa musi
 * przyjechać z konta, a nie z `localStorage` jednego telefonu.
 */
/** Kolejność jak na kole barw, żeby dwa podobne odcienie stały obok siebie i dały się porównać. */
export const AKCENTY = [
    ["zielony", "Zielony"],
    ["seledynowy", "Seledynowy"],
    ["niebieski", "Niebieski"],
    ["granatowy", "Granatowy"],
    ["czerwony", "Czerwony"],
    ["pomaranczowy", "Pomarańczowy"],
    ["zolty", "Żółty"],
    ["brazowy", "Brązowy"],
    ["grafitowy", "Grafitowy"],
];
export const DOMYSLNY_AKCENT = "zielony";
/** Wejście jest niezaufane: idzie z bazy, z `localStorage` i z ciała żądania. */
export function parsujAkcent(surowa) {
    return AKCENTY.some(([wartosc]) => wartosc === surowa) ? surowa : DOMYSLNY_AKCENT;
}
/**
 * Kolory pionków w jednej partii — po jednym na gracza, bez powtórzeń.
 *
 * Kolory na kontach nie są unikalne, bo w ustawieniach nie ma powodu ich
 * pilnować. Dopiero na wspólnej planszy dwa identyczne pionki są nie do
 * odróżnienia, więc kolizję rozstrzygamy tutaj — raz, przy `init`, a wynik ląduje
 * w stanie partii. Dzięki temu zmiana koloru w Opcjach w trakcie rozgrywki nie
 * przemalowuje planszy pod graczami.
 *
 * Barw jest dziewięć, graczy najwyżej czterech, więc wolna zawsze się znajdzie.
 */
export function przydzielKolory(gracze, preferencje) {
    const wolne = AKCENTY.map(([wartosc]) => wartosc);
    const zajete = new Set();
    const wynik = {};
    for (const gracz of gracze) {
        const chciany = preferencje[gracz] ?? DOMYSLNY_AKCENT;
        const start = wolne.indexOf(chciany);
        let wybrany = chciany;
        for (let krok = 0; krok < wolne.length; krok += 1) {
            const kandydat = wolne[(start + krok) % wolne.length];
            if (!zajete.has(kandydat)) {
                wybrany = kandydat;
                break;
            }
        }
        zajete.add(wybrany);
        wynik[gracz] = wybrany;
    }
    return wynik;
}
//# sourceMappingURL=kolory.js.map